/**
 * Allows for wrapping around to the start of a list when incrementing or
 * decrementing the index.
 */
function getIndex(moveAmount: 1 | -1, current: number | null, total: number) {
  const maxIndex = total - 1;

  if (current === null) {
    return moveAmount > 0 ? 0 : maxIndex;
  }

  const nextIndex = moveAmount + current;

  if (nextIndex > maxIndex) {
    return 0;
  }

  if (nextIndex < 0) {
    return maxIndex;
  }

  return nextIndex;
}

export function getNextIndex(current: number | null, total: number) {
  return getIndex(1, current, total);
}

export function getPreviousIndex(current: number | null, total: number) {
  return getIndex(-1, current, total);
}
